import {Component} from '@angular/core';

@Component({
  selector: 'answer-ico',
  templateUrl: './answer-ico.component.html'
})
export class AnswerIcoComponent {
}
